import { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import { toPng } from "html-to-image";
import { ErrorBoundary } from "react-error-boundary";
import PieChart from "components/Graph/PieChart";
import { GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_COLORS } from "config/constants";
import { getGoalTrackingPercentage } from "helpers/common";
import ErrorComponent from "components/shared/ErrorComponent";

const SessionOutcomePieChart = forwardRef(({ trackingData }, ref) => {
  const chartRef = useRef(null);

  const { series, colors, labels } = useMemo(() => {
    let series = [];
    let colors = [];
    let labels = [];
    Object.entries(GOAL_TRACK_PARAMETERS).forEach(([param, label], index) => {
      let parameterPercentage = getGoalTrackingPercentage(param, trackingData);
      if (!parameterPercentage) return;

      series.push(parameterPercentage);
      labels.push(`${param} - ${label}`);
      colors.push(GOAL_TRACK_PARAMETERS_COLORS[param]);
    });
    return {
      series,
      labels,
      colors,
    };
  }, [trackingData]);

  useImperativeHandle(ref, () => ({
    generateImage: async () => {
      if (chartRef.current) {
        try {
          const dataUrl = await toPng(chartRef.current, { pixelRatio: 2 });
          return dataUrl;
        } catch (error) {
          console.error("Error generating chart image", error);
        }
      }
    },
  }));

  return (
    <ErrorBoundary fallback={<ErrorComponent />}>
      <div ref={chartRef}>
        <PieChart series={series} colors={colors} labels={labels} />
      </div>
    </ErrorBoundary>
  );
});

export default SessionOutcomePieChart;
